import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { BrowserModule } from '@campus/browser';
import { ComponentsModule, DcrDialogRef } from '@campus/components';
import '@diekeure/dcr-components/dcr-image.js';

export interface ContentPreviewData {
  url?: string;
  html?: string;
}

@Component({
  selector: 'campus-dcr-content-preview-dialog',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ComponentsModule, BrowserModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
  template: `
    @if (data?.url) {
      <dcr-image [attr.src]="data.url" fit="contain" class="w-full"></dcr-image>
    }
    @if (data?.html) {
      <campus-froala-viewer class="[ container overflow-x-auto ]" [content]="data.html | safeHtml"></campus-froala-viewer>
    }
  `,
})
export class DcrContentPreviewDialogComponent {
  private dialogRef = inject<DcrDialogRef<ContentPreviewData>>(DcrDialogRef);
  protected data = this.dialogRef.data;
}
